import React from 'react';
import styled, { css } from 'styled-components';
import { typography } from '../../lib/styles';
import { between } from '../../spa/core-components/utils/media';

const Wrapper = styled.div<{ gradient: string[] }>(({ gradient }) => {
    return css`
        h1,
        &:after {
            font-size: 80px;
            font-family: ${typography.fontFamilies.heading};
            line-height: 1.15;
            letter-spacing: ${typography.letterSpacing.h0};
            margin: 0;
            width: fit-content;
            background-color: ${gradient[0]};
            background-image: linear-gradient(50deg, ${gradient[0]}, ${gradient[1]} 90%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -moz-background-clip: text;
            -moz-text-fill-color: transparent;
            max-width: 820px;

            ${between('small', 'medium')} {
                font-size: ${typography.typeScale.size8}px;
                letter-spacing: ${typography.letterSpacing.h1};
            }
        }

        &:after {
            content: '—';
            display: block;
            background-image: none;
        }
    `;
});

interface Props {
    children: React.ReactNode;
    gradient: string[];
    className?: string;
}

const HeroGradientHeading = ({ children, gradient, className = '' }: Props) => (
    <Wrapper gradient={gradient} className={className}>
        <h1>{children}</h1>
    </Wrapper>
);

export default HeroGradientHeading;
